<template>
  <div :key="$store.getters['resource/currentResource'].key">

    <loader v-if="loading" :styleObject="{height: '160px!important'}"/>

    <b-form
      v-else
      @submit.prevent="debounceSubmit"
      novalidate>

      <!-- Main fields -->
      <b-row class="align-items-center mb-3">
        <loader v-if="triggerFieldsLoading"></loader>

        <b-col md="4">
          <label class="d-block"> Trigger
            <span class="text-danger">{{$t('form.required_star')}}</span>
          </label>
          <multiselect
                  v-model="params.trigger"
                  :loading="isSelectLoading.triggers"
                  deselectLabel="X"
                  selectLabel=""
                  selectedLabel=""
                  :multiple="false"
                  label="title"
                  track-by="title"
                  :options="triggers"
                  @search-change="query => {debounceGetSelectOptions('triggers?limit=100', 'triggers', 'title', query)}"
                  @input="getTriggerFields()"
                  @remove="triggerFields = []">
            <template slot="noResult">
              {{$t('global.no_results')}}
            </template>
          </multiselect>

          <div class="invalid-feedback position-absolute mt-0 text-left"
               :class="[formValidated && !params.trigger ? 'd-block' : '']"
               style="bottom: -16px">
            {{$t('errors.error_validation')}}
          </div>
        </b-col>

        <b-col md="2" class="mt-4">
          <b-form-checkbox v-model="params.active">
            {{$t('form.active')}}
          </b-form-checkbox>
        </b-col>

        <b-col md="2" class="mt-4">
          <b-form-checkbox v-model="params.is_send_empty">
            {{$t('triggers.send_empty_email')}}
          </b-form-checkbox>
        </b-col>

        <b-col v-for="(field, index) in triggerFields"
               :key="index"
               class="mt-3"
               md="6">

          <label class="d-block"> {{field.title}}
            <span v-if="field.required" class="text-danger">{{$t('form.required_star')}}</span>
          </label>

          <b-input v-if="field.type === 'input'"
                   :name="field.name"
                   v-model="params.settings[field.name]"/>
          <multiselect v-else-if="field.type === 'multi_select' || field.type === 'select'"
                       v-model="params.settings[field.name]"
                       deselectLabel="X"
                       selectLabel=""
                       selectedLabel=""
                       :multiple="field.type === 'multi_select'"
                       label="title"
                       value="value"
                       track-by="title"
                       :options="field.options">
            <template slot="noResult">
              {{$t('global.no_results')}}
            </template>
          </multiselect>

          <div class="invalid-feedback position-absolute mt-0 text-left"
               :class="[formValidated && !params.settings[field.name] && field.required ? 'd-block' : '']"
               style="bottom: -16px">
            {{$t('errors.error_validation')}}
          </div>

        </b-col>

      </b-row>

      <form-buttons></form-buttons>

    </b-form>

  </div>
</template>
<script>
  import axios from '@/utils/axios';
  import FormFields from '@/components/global/formFields';

  export default {
    middleware: 'auth',
    components: {
      FormFields
    },
    props: {
      prefillParams: {
        type: Object
      },
    },
    data: () => {
      return {
        formValidated: false,
        isSelectLoading: {},
        loading: true,
        triggerFieldsLoading: false,
        params: {
          active: true,
          trigger: null,
          is_send_empty: false,
          settings: {}
        },
        triggers: [],
        triggerFields: [],
        showAddMore: false,
        debounceSubmit: () => {
        },
        debounceGetSelectOptions: () => {
        }
      }
    },
    created() {
      if (this.prefillParams) {
        this.createPrefillParams()
      }
      this.getSelectOptions('triggers?limit=100', 'triggers');
      this.debounceSubmit = _.debounce(this.submit, 1000);
      this.debounceGetSelectOptions = _.debounce(this.getSelectOptions, 500);
    },
    computed: {
      formIsFilled() {
        let invalid = this.triggerFields.some((field) => {
          if (field.required) {
            if (Array.isArray(this.params.settings[field.name])) {
              return !this.params.settings[field.name].length;
            }

            return !this.params.settings[field.name];
          }
        });

        return !!this.params.trigger && !invalid;
      }
    },
    methods: {
      createPrefillParams() {
        this.params.active = this.prefillParams.active;
        this.params.is_send_empty = this.prefillParams.is_send_empty;

        if (this.prefillParams.trigger) {
          this.params.trigger = this.prefillParams.trigger;
        }

        if (this.prefillParams.settings) {
          this.params.settings = this.prefillParams.settings;
        }

        this.getTriggerFields();

        this.$forceUpdate();
      },
      getSelectOptions(url, name, filter_field = null, value = null) {
        this.$set(this.isSelectLoading, name, true);
        const params = {filter: {}};
        if (filter_field && value) {
          params.filter[filter_field] = value
        }
        try {
          this.getData(url, {params}).then(({data}) => {
            this[name] = data.items
          }).then(() => {
            this.$set(this.isSelectLoading, name, false);
          })
        } catch (e) {
          console.log(e)
        } finally {
          this.$forceUpdate();
          this.loading = false;
        }
      },
      submit() {
        this.formValidated = true;

        if (this.formIsFilled) {

          let clonedParams = _.cloneDeep(this.params);

          let params = {};
          _.mapKeys(clonedParams, (value, key) => {
            if (value) {
              if (value.value !== undefined) {
                params[key] = value.value
              } else if (value.id) {
                params[key] = value.id
              } else {
                params[key] = value
              }
            }
          });

          if (this.params.trigger) {
            params.trigger_id = this.params.trigger.id;
          }

          if (params.settings) {
            _.mapKeys(params.settings, (value, key) => {
              if (value) {
                if (Array.isArray(value)) {
                  params.settings[key] = value.map((item) => {
                    return item ? item.value : null;
                  });
                }

                if (value.value !== undefined) {
                  params.settings[key] = value.value;
                }
              }
            });
          }

          this.$emit('save', params);
        }
      },
      getTriggerFields() {
        if (!this.params.trigger) return;

        this.triggerFieldsLoading = true;

        this.triggerFields = [];

        const {id: triggerId} = this.params.trigger;

        try {
          this.getData(`triggers/${triggerId}`).then(({data}) => {
            if (data) {
              this.triggerFields = data.items;

              this.prefillTriggerFields();
            }
          }).finally(() => this.triggerFieldsLoading = false);
        } catch (e) {
          console.log(e);
        }
      },
      prefillTriggerFields() {
        this.triggerFields.forEach((field) => {
          if (field.type === 'multi_select') {
            if (this.params.settings[field.name]) {
              this.params.settings[field.name] = field.options.filter((item) => this.params.settings[field.name].includes(item.value));
            }
          }

          if (field.type === 'select') {
            if (this.params.settings[field.name]) {
              this.params.settings[field.name] = field.options.find((item) => item.value === this.params.settings[field.name]);
            }
          }
        });
      }
    },
  }
</script>
